(() => {
  const SECTION_SELECTOR = '.custom-guides-hero-v2';
  const SCROLL_BUTTON_SELECTOR = '[data-guides-scroll-button]';

  function initReveal(section) {
    if (section.classList.contains('custom-guides-hero-v2--animate')) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                section.classList.add('is-visible');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.16 }
        );

        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }
    } else {
      section.classList.add('is-visible');
    }
  }

  function initScrollButton(section) {
    const button = section.querySelector(SCROLL_BUTTON_SELECTOR);
    if (!button) return;

    button.addEventListener('click', (event) => {
      const href = button.getAttribute('href');

      if (!href || !href.startsWith('#') || href === '#') return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', href);
      }
    });
  }

  function initSection(section) {
    if (
      !section ||
      section.dataset.customGuidesHeroV2Initialized === 'true'
    ) {
      return;
    }

    section.dataset.customGuidesHeroV2Initialized = 'true';

    initReveal(section);
    initScrollButton(section);
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }

    scope.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
